const Shader_Arc = {
  vert: `uniform mat4 matrix_viewProjection;
    uniform mat4 matrix_model;
    
    // Additional inputs
    attribute vec3 vertex_position;
    attribute vec2 vertex_texCoord0;
    
    // Additional shader outputs
    varying vec2 vUv0;
    
    void main(void) {
        // UV is simply passed along as varying
        vUv0 = vertex_texCoord0;
    
        // Position for screen-space
        gl_Position = matrix_model * vec4(vertex_position, 1.0);
        gl_Position.zw = vec2(0.0, 1.0);
    }`,
  frag: `precision mediump float;
    #define PI 3.14159265359
    #define TWO_PI 6.28318530718
    
    uniform float angle;
    uniform float innerRadius;
    uniform vec3 col;
    uniform float opacity;
    uniform float feather;
    
    // Additional varying from vertex shader
    varying vec2 vUv0;
    
    float clockWipe(vec2 p, float angle)
    {
        float a=atan(-p.x,-p.y);
        // float v = smoothstep(a+PI, a+PI, angle*TWO_PI);
        float v = smoothstep((a+PI)-0.05, (a+PI), angle * TWO_PI);
        return v;
    }
    float circle(in vec2 _st, in float _radius){
        vec2 dist = _st-vec2(0.5);
        return 1.-smoothstep(_radius-(_radius*feather),
                             _radius+(_radius*feather),
                             dot(dist,dist)*(4.0 + (feather*4.0)));
    }

    void main(){
        vec2 uv = vUv0 - vec2(0.5,0.5);
        // float clock = clockWipe(uv,angle);

        float clock = circle(uv+vec2(0.5,0.5), 1.0);
        clock-=circle(uv+vec2(0.5,0.5), innerRadius);
        clock*= clockWipe(uv,angle);
        vec3 color=vec3(col);
        gl_FragColor=vec4(color, clock*opacity);
    }`,
};
export {Shader_Arc};
